import Big from 'big.js';

export const feeFields = ['installFee', 'leakageDeduction', 'insuranceDeduction', 'regionalSubsidy', 'specialSubsidy', 'monthlySubsidy'];
const deductionFields = new Set(['leakageDeduction', 'insuranceDeduction']);

export function withAccountingFee(row) {
  const result = { ...row };
  feeFields.forEach(key => { result[key] = new Big(row[key] == null || row[key] === '' ? 0 : row[key]).toString(); });
  result.accountingFee = feeFields.reduce((sum, key) => deductionFields.has(key)
    ? sum.minus(result[key]) : sum.plus(result[key]), new Big(0)).toString();
  return result;
}
